import { render } from "./AudioPlayer.vue?vue&type=template&id=38c5625b"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"
script.render = render

export default script